import { render } from "./_form-sms.vue?vue&type=template&id=bb22d624"
import script from "./_form-sms.vue?vue&type=script&lang=js"
export * from "./_form-sms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__